<template>
  <div>
    <card-seplag :titulo="textoCabecalho">
      <div class="cardButtonFile">
        <Rotulo
          nome="Anexe/Envie o documento para refificação da Declaração Anual de Pessoa Física."
          cols="12"
          class="rotulo"
        >
          <FileUpload
            name="file[]"
            accept="application/pdf"
            :maxFileSize="3028000"
            chooseLabel="Quadros da Declaração de Imposto de Renda"
            uploadLabel="Enviar"
            cancelLabel="Cancelar"
            :fileLimit="1"
            :previewWidth="60"
            invalidFileSizeMessage="{0}: Tamanho de arquivo inválido, o tamanho do arquivo deve ser menor que 3MB."
            invalidFileLimitMessage="Número máximo de arquivo excedido, o limite é {0} no máximo"
            @select="onUploadIR"
            :customUpload="true"
            :showUploadButton="false"
            :showCancelButton="false"
            ref="inputFile"
          >
            <template #empty>
              <div class="display-flex-center">
                <i class="pi pi-download icon-arraste"></i>
                <p class="texto-arraste">Escolha o arquivo ou arraste aqui</p>
              </div>
            </template>
          </FileUpload>
        </Rotulo>
        <Rotulo
          nome="Justificativa da Retificação da Declaração Anual de Pessoa Física."
          cols="12"
          class="rotulo"
        >
          <Textarea
            v-model="justificativa"
            :autoResize="true"
            rows="5"
            cols="30"
            @keyup="keyupFn()"
          />
          <div class="contador-caracteres">
            <span>
              {{
                QtdMaximoCaracteres - (justificativa ? justificativa.length : 0)
              }}
              caracteres restantes</span
            >
          </div>
        </Rotulo>
        <Rotulo
          nome="Documento para enviados da Declaração Anual de Pessoa Física."
          cols="12"
          class="rotulo"
        >
          <DataTable
            :value="listaArquivoIR"
            class="p-datatable-responsive-demo p-datatable-gridlines"
            v-if="listaArquivoIR.length > 0"
            :rowClass="rowClass"
          >
            <Column
              field="arquivo.tipoExtensaoArquivo"
              header="Extensão"
              headerStyle="width: 8rem"
              bodyClass="columnAlign"
            >
              <template #body="slotProps">
                <span class="p-column-title">Extensão:</span>
                {{ slotProps.data.arquivo.tipoExtensaoArquivo }}
              </template>
            </Column>

            <Column
              field="arquivo.descArquivo"
              header="Arquivo"
              bodyClass="columnAlign"
            >
              <template #body="slotProps">
                <span class="p-column-title">Arquivo:</span>
                <span>{{ slotProps.data.arquivo.descArquivo }}</span>
              </template>
            </Column>

            <Column
              headerStyle="width: 8em"
              bodyClass="columnAlign"
              header="Ação"
            >
              <template #body="slotProps">
                <Button
                  type="button"
                  icon="pi pi-print"
                  @click="download(slotProps.data.arquivo.idenArquivo)"
                  class="p-button-raised"
                />
              </template>
            </Column>
          </DataTable>
        </Rotulo>
      </div>

      <div class="p-col-12">
        <div class="avisos">
          <p>Apenas arquivos PDF de no máximo 3mb cada.</p>
        </div>
      </div>

      <div class="p-col p-md-6">
        <div class="p-grid" v-if="permiteExecutarAcao">
          <div class="p-col-12 p-md-6">
            <Button
              label="Voltar"
              class="p-button-raised p-button-rounded p-button-text"
              @click="voltar()"
            />
          </div>
          <div class="p-col-12 p-md-6" v-if="isPermitirNovo">
            <Button
              label="Finalizar Retificação"
              class="p-button-raised p-button-rounded p-button-success"
              @click="abreDialogo()"
              :disabled="!isPermitirNovo"
            />
          </div>
          <div class="p-col-12 p-md-6" v-if="!isPermitirNovo">
            <Button
              class="p-button-raised p-button-rounded p-button-warning"
              label="Editar Retificação"
              @click="abreDialogoEdicao()"
              :disabled="!isPermitirEditar"
            ></Button>
          </div>
        </div>
      </div>

      <Dialog
        :header="'Confirmação de Envio'"
        :visible.sync="dialogConfirmacao"
        class="dialogo-termo-aceite"
        :contentStyle="{ width: '30vw' }"
        :modal="true"
      >
        <div class="confirmation-content texto-centro">
          <span
            >Você tem certeza que gostaria de finalizar esta retificação?</span
          >
        </div>
        <template #footer>
          <Button
            label="Não"
            icon="pi pi-times"
            @click="fecharDialogo"
            class="p-button-text"
          />
          <Button
            label="Sim"
            icon="pi pi-check"
            @click="salvarRetificacao()"
            class="p-button-text"
            autofocus
            :disabled="!isPermitirEditar"
          />
        </template>
      </Dialog>

      <Dialog
        :header="'Confirmação de Edição'"
        :visible.sync="dialogConfirmacaoEdicao"
        class="dialogo-termo-aceite"
        :contentStyle="{ width: '30vw' }"
        :modal="true"
      >
        <div class="confirmation-content texto-centro">
          <span> Você tem certeza que deseja EDITAR essa retificacao?</span>
        </div>
        <template #footer>
          <Button
            label="Não"
            icon="pi pi-times"
            @click="fecharDialogoEdicao"
            class="p-button-text"
          />
          <Button
            label="Sim"
            icon="pi pi-check"
            @click="editarRetificacao"
            class="p-button-text"
            autofocus
            :disabled="!isPermitirEditar"
          />
        </template>
      </Dialog>
    </card-seplag>

    <CardExibirPDF
      :tamanhoTela="'85,vw'"
      :alturaTela="'120,vh'"
      :pdfElement="dadosRelatorioBase64"
      v-model="isExibirPDF"
      :tituloTela="tituloPDF"
      v-if="isExibirPDF"
    />
  </div>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import { baseApiUrl, printToast } from "@/config/global";
import CardExibirPDF from "@/template/CardExibirPDF";

export default {
  name: "declaracaoArqFederal",
  components: { CardSeplag, Rotulo, CardExibirPDF },
  data: function () {
    return {
      dialogConfirmacao: false,
      dialogConfirmacaoEdicao: false,
      listaArquivoIR: [],
      listaArquivoRecibo: [],
      dadosRelatorioBase64: "",
      isExibirPDF: false,
      tituloPDF: " ",
      tituloAlterarArquivo: "",
      isShowDialogAlterarArquivo: false,
      formData: null,
      changeArquivoObj: null,
      idenContaAcesso: 0,
      changeFileLabel: "",
      permiteExecutarAcao: "NAO_INFORMADO",
      isPermitirEditar: true,
      isPermitirNovo: true,
      textoCabecalho: "Carregando....",
      justificativa: "",
      arquivoSelecionado: null,
      QtdMaximoCaracteres: 200,
      codArquivoRetificado: null,
    };
  },
  methods: {
    carregarDados() {
      this.idenContaAcesso = this.$store.getters.getUser.contaAcesso.id;
      if (this.$route.params.id) {
        this.idenPessoaExercicio = this.$route.params.id;
        this.$http
          .get(
            `${baseApiUrl}/pessoaexercicios/resumo/${this.idenPessoaExercicio}`
          )
          .then((res) => {
            this.parmForm = res.data;
            this.listaArquivoIR = res.data.arquivosDeclaracao;
            this.textoCabecalho =
              res.data.nomePessoa +
              " - Exercício " +
              res.data.parametroExercicio.anoExercicio;
            this.justificativa = res.data.descJustRetificacao
              ? res.data.descJustRetificacao
              : "";
            this.listaArquivoIR = this.listaArquivoIR.map((item) => {
              let aux = { ...item };
              if (
                item.tipoDocDeclaracaoBem.tipoDocumento.siglTipoDocumento ==
                "RETIFICACAODECLBENS"
              ) {
                this.isPermitirNovo = false;
                this.codArquivoRetificado = item.idenArquivoDeclaracaoBem;
              }
              if (aux.flagFrontAcao == "VALIDADO") {
                aux.arquivo.descArquivo = `${aux.arquivo.descArquivo} (APROVADO)`;
              } else if (aux.flagFrontAcao == "RECUSADO") {
                aux.arquivo.descArquivo = `${
                  aux.arquivo.descArquivo
                } (RECUSADO - ${
                  aux.listaRejeicaoArquivo
                    ? aux.listaRejeicaoArquivo[0].motivoRejeicao
                        .descMotivoRejeicao
                    : ""
                })`;
              }

              return aux;
            });

            this.listaArquivoRecibo = this.listaArquivoRecibo.map((item) => {
              let aux = { ...item };

              if (aux.flagFrontAcao == "VALIDADO") {
                aux.arquivo.descArquivo = `${aux.arquivo.descArquivo} (APROVADO)`;
              } else if (aux.flagFrontAcao == "RECUSADO") {
                aux.arquivo.descArquivo = `${
                  aux.arquivo.descArquivo
                } (RECUSADO - ${
                  aux.listaRejeicaoArquivo
                    ? aux.listaRejeicaoArquivo[0].motivoRejeicao
                        .descMotivoRejeicao
                    : ""
                })`;
              }
              return aux;
            });
            this.idenContaAcesso = this.$store.getters.getUser.contaAcesso.id;
          });
      } else {
        this.$router.push({
          path: `/${process.env.VUE_APP_BASE_URL}/modulo-rh/retificacao/lista`,
        });
      }
    },

    voltar() {
      this.$router.push({
        path: `/${process.env.VUE_APP_BASE_URL}/modulo-rh/retificacao/lista`,
      });
    },

    fecharDialogo() {
      this.dialogConfirmacao = false;
    },
    // onError(erro) {
    //   console.log(erro);
    // },
    abreDialogo() {
      this.dialogConfirmacao = true;
    },

    fecharDialogoEdicao() {
      this.dialogConfirmacaoEdicao = false;
    },

    abreDialogoEdicao() {
      this.dialogConfirmacaoEdicao = true;
    },

    salvarRetificacao() {
      if (this.isPermitirEditar) {
        if (
          (this.arquivoSelecionado &&
            this.arquivoSelecionado.files.length == 0) ||
          this.arquivoSelecionado == null
        ) {
          printToast({
            severity: "error",
            detail:
              "Arquivo não selecionado, Por Favor Selecione um arquivo de Retificação antes de Finalizar.",
            summary: "Erro ao Finalizar",
          });
          this.dialogConfirmacao = false;
          return;
        }
        if (this.justificativa == null || this.justificativa.length < 20) {
          printToast({
            severity: "error",
            detail:
              "Justificativa não preenchida, Por Favor Preencha a justificativa com no minimo 20 caracteres antes de Finalizar.",
            summary: "Erro ao Finalizar",
          });
          this.dialogConfirmacao = false;
          return;
        }
        let formData = new FormData();
        formData.append("file", this.arquivoSelecionado.files[0]);
        formData.append("justificativa", this.justificativa);
        this.$http
          .post(
            `${baseApiUrl}/pessoaexercicios/retificacao/finalizar/arquivo/${this.idenPessoaExercicio}/${this.idenContaAcesso}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then(() => {
            this.dialogConfirmacao = false;
            this.arquivoSelecionado = null;
            this.$refs.inputFile.clear();
            printToast({
              severity: "success",
              summary: "Retificação Criada Com Sucesso",
            });
            this.carregarDados();
          });
      }
    },
    editarRetificacao() {
      if (this.isPermitirEditar) {
        if (
          (this.arquivoSelecionado &&
            this.arquivoSelecionado.files.length == 0) ||
          this.arquivoSelecionado == null
        ) {
          printToast({
            severity: "error",
            detail:
              "Arquivo não selecionado, Por Favor Selecione um arquivo de Retificação antes de Editar.",
            summary: "Erro ao Finalizar",
          });
          this.dialogConfirmacao = false;
          return;
        }
        if (this.justificativa == null || this.justificativa.length < 20) {
          printToast({
            severity: "error",
            detail:
              "Justificativa não preenchida, Por Favor Preencha a justificativa com no minimo 20 caracteres antes de Editar.",
            summary: "Erro ao Finalizar",
          });
          this.dialogConfirmacao = false;
          return;
        }
        let formData = new FormData();
        formData.append("file", this.arquivoSelecionado.files[0]);
        formData.append("justificativa", this.justificativa);
        this.$http
          .post(
            `${baseApiUrl}/pessoaexercicios/retificacao/editar/arquivo/${this.idenPessoaExercicio}/${this.idenContaAcesso}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then(() => {
            this.dialogConfirmacao = false;
            this.arquivoSelecionado = null;
            this.$refs.inputFile.clear();
            printToast({
              severity: "success",
              summary: "Retificação Editada",
            });
            setTimeout(() => {
              this.voltar();
            }, 500);
          });
      }
    },
    onUploadIR(data) {
      if (this.isPermitirEditar) {
        this.arquivoSelecionado = data;
      }
    },
    download(idenArquivoDecaracaoBem) {
      this.$http
        .get(
          `${baseApiUrl}/arquivodeclaracaobens/download/base64/${idenArquivoDecaracaoBem}`
        )
        .then((res) => {
          this.dadosRelatorioBase64 = res.data;
          this.isExibirPDF = true;
        });
    },
    rowClass(data) {
      return data.flagFrontAcao == "VALIDADO"
        ? "arquivo-aceito"
        : data.flagFrontAcao == "RECUSADO"
        ? "arquivo-recusado"
        : null;
    },
    keyupFn() {
      if (
        this.justificativa &&
        this.QtdMaximoCaracteres - this.justificativa.length < 0
      ) {
        this.justificativa = this.justificativa.substring(
          0,
          this.QtdMaximoCaracteres
        );
      }
    },
  },
  mounted() {
    this.carregarDados();
  },
};
</script>

<style lang="scss" scoped >
#botaoFim {
  font-size: 1.5vw;
  width: 11vw;
  text-align: center;
}

.cardButtonFile {
  width: 100%;
}

.texto-centro {
  text-align: center;
}

.arquivo-federal-container {
  margin: auto auto;
}

.avisos {
  text-align: center;
  background-color: rgb(231, 232, 125); /* Yellow */
  color: #000000;
  border-radius: 12px;
  font-size: 1.142rem;
  font-weight: bold;
  // width: 50vw;
}

// @media screen and (min-width: 100rem){
//     .arquivo-federal-container{
//         margin: auto 20rem;
//     }
// }

.rotulo {
  margin: 1rem auto;
}

.columnAlign {
  text-align: center;
}

.p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

@media screen and (max-width: 60em) {
  /deep/ .p-datatable {
    &.p-datatable-responsive-demo {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-row {
        display: flex;
        flex-direction: column;
      }
      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;

        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }

        &:last-child {
          border-bottom: 1px solid var(--surface-d);
          text-align: center !important;
          display: flex !important;

          & button {
            width: 100%;
          }
        }
      }
    }
  }
}

.icon-arraste {
  font-size: 2rem;
  margin: 1rem 1rem;
}

.display-flex-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>


<style>
.arquivo-aceito {
  background-color: #6cb358 !important;
}

.arquivo-aceito td,
.arquivo-recusado td {
  color: #191010;
  font-size: 1.1rem;
  font-weight: 500;
}

.arquivo-recusado {
  background-color: #ea5d5d !important;
}
</style>